import { AppThunkAction } from '../../reducers';
import { CrearLlamadoRequest, Llamado } from '../../../models/Entities/Turnero';
import { ErrorType } from '../../../models/HttpError';

// services
import * as Services from '../../../services/Turnero-Llamados.Services';

// actions
import * as ActionEvents from '../../actions/Turnero-Llamados.Actions';
import {
    TurneroLlamadosCrearFailureAction,
    TurneroLlamadosCrearRequestAction,
    TurneroLlamadosCrearSuccessAction,
    TurneroLlamadosGetUltimosFailureAction,
    TurneroLlamadosGetUltimosRequestAction,
    TurneroLlamadosGetUltimosSuccessAction,
    TurneroLlamadosPurgeOldFailureAction,
    TurneroLlamadosPurgeOldRequestAction,
    TurneroLlamadosPurgeOldSuccessAction
} from '../../actions/Turnero-Llamados.Actions';

type KnownAction =
    | TurneroLlamadosCrearRequestAction
    | TurneroLlamadosCrearSuccessAction
    | TurneroLlamadosCrearFailureAction
    | TurneroLlamadosGetUltimosRequestAction
    | TurneroLlamadosGetUltimosSuccessAction
    | TurneroLlamadosGetUltimosFailureAction
    | TurneroLlamadosPurgeOldRequestAction
    | TurneroLlamadosPurgeOldSuccessAction
    | TurneroLlamadosPurgeOldFailureAction;

export const actionCreators = {
    CrearLlamado: (payload: CrearLlamadoRequest): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_LLAMADOS_CREAR_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_LLAMADOS_CREAR_REQUEST,
            payload
        });

        Services.CrearLlamado(token, payload)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_CREAR_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_CREAR_FAILURE,
                    error
                });
            });
    },
    GetUltimosLlamados: (sectorId: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_LLAMADOS_GET_ULTIMOS_FAILURE,
                sectorId,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_LLAMADOS_GET_ULTIMOS_REQUEST,
            sectorId
        });

        Services.GetUltimosLlamadosPorSector(token, sectorId)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_GET_ULTIMOS_SUCCESS,
                    sectorId,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_GET_ULTIMOS_FAILURE,
                    sectorId,
                    error
                });
            });
    },
    PurgeOldLlamados: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (token === null) {
            dispatch({
                type: ActionEvents.TURNERO_LLAMADOS_PURGE_OLD_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.TURNERO_LLAMADOS_PURGE_OLD_REQUEST
        });

        Services.PurgeOldLlamados(token)
            .then((response) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_PURGE_OLD_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.TURNERO_LLAMADOS_PURGE_OLD_FAILURE,
                    error
                });
            });
    }
};
